import Api from "@/lib/axios";

const UsersService = {
  createUser(params) {
    return Api.post("/api/autopricing/users", params);
  },

  patchUser(params) {
    return Api.patch(`/api/autopricing/users/${params.id}`, params);
  },

  deleteUser(params) {
    return Api.delete(`/api/autopricing/users/${params.id}`);
  },

  async getUsers(payload) {
    const data = {
      ...payload,
      page: (payload.page || 1) - 1
    };
    const response = await Api.get("/api/autopricing/users", {
      data
    });
    const list = response?.data?.content || [];
    const pagination = response?.data?.pageable || {};

    return {
      list,
      pagination: {
        ...pagination,
        totalElements: response?.data?.totalElements,
        totalPages: response?.data?.totalPages
      }
    };

  }

}

export default UsersService;
